import type { PhrasingContent } from 'mdast';
import { MALFORMED_CHECKBOX_REGEX } from './malformed-checkbox-regex';

/**
 * Given the inline children of the first paragraph of a malformed task item,
 * strips the leading `[ ]` / `[x]` / `[X]` prefix from the first text node.
 * Returns the adjusted inline array (may be empty if the item had no other content).
 */
export function stripMalformedCheckboxPrefix(inlines: PhrasingContent[]): PhrasingContent[] {
	const [firstInline, ...rest] = inlines;
	if (!firstInline || firstInline.type !== 'text') {
		return inlines;
	}
	const stripped = firstInline.value.replace(MALFORMED_CHECKBOX_REGEX, '').trimStart();
	return stripped.length > 0 ? [{ ...firstInline, value: stripped }, ...rest] : rest;
}
